import { SplitsLink } from '~/components/Link'
import { Message } from '~/components/component-library'

export const StateChangeErrorMessage = ({
  errorMessage,
  isSimulationRevert,
}: {
  errorMessage?: string
  isSimulationRevert?: boolean
}) => {
  const fallbackMessage = isSimulationRevert ? (
    <span>No revert reason provided</span>
  ) : (
    <span>
      Proceed with caution and contact us at{' '}
      <SplitsLink path="mailto:support@splits.org">
        support@splits.org
      </SplitsLink>{' '}
      if the issue persists
    </span>
  )

  return (
    <Message
      variant="warning"
      title={
        isSimulationRevert
          ? 'Simulation reverted'
          : 'Unable to simulate transaction'
      }
    >
      {errorMessage ? <span>{errorMessage}</span> : fallbackMessage}
    </Message>
  )
}
